import { RegionalDirection } from '@model/enumerations/regional-direction.model';

export interface ILocalityClient {
  id?: number;
  districtName?: string;
  countyName?: string;
  localityName?: string;
  nut1?: string;
  nut1cod?: string;
  nut2?: string;
  nut2cod?: string;
  nut3?: string;
  nut3cod?: string;
  localityFullCode?: string;
  regionalDirection?: RegionalDirection;
}

// noinspection JSUnusedGlobalSymbols
export class LocalityClient implements ILocalityClient {
  constructor(
    public id?: number,
    public districtName?: string,
    public countyName?: string,
    public localityName?: string,
    public nut1?: string,
    public nut1cod?: string,
    public nut2?: string,
    public nut2cod?: string,
    public nut3?: string,
    public nut3cod?: string,
    public localityFullCode?: string,
    public regionalDirection?: RegionalDirection
  ) {}
}
